import moment from 'moment';

import { isUndefined, isArray, isStringEmpty } from '../../../utils/isDefined';
import Optional from '../../../utils/optional';

export const mapTemplate = template => {
  if (isUndefined(template)) {
    return {};
  }
  const { attributes } = template;

  return attributes.reduce((obj, el) => {
    if (el.valueType === 'Date') {
      return { ...obj, [el.label]: Optional(el.defaultValue).or(moment()) };
    }

    if (el.valueType === 'Boolean') {
      return { ...obj, [el.label]: Optional(el.defaultValue).or(false) };
    }

    return { ...obj, [el.label]: Optional(el.defaultValue).or('') };
  }, {});
};

export const findProductPrices = product => {
  if (isUndefined(product?.prices) || !isArray(product?.prices)) {
    return {
      setupPrice: '',
      price: ''
    };
  }

  const foundedPrices = product?.prices.find(el => el.sku === product.sku);

  if (isUndefined(foundedPrices)) {
    return {
      setupPrice: '',
      price: ''
    };
  }

  return {
    setupPrice: Optional(Number(foundedPrices.setupPrice) / 100).or(0),
    price: Optional(Number(foundedPrices.price) / 100).or(0)
  };
};

const ESIM_SIGNUP_PRIMARY_NAME = 'phone-and-sim-card.esim-signup-primary';
const SIM_CARDS_PRIMARY_NAME = 'phone-and-sim-card.resources-sim-cards-primary';

export const customValidation = (template, values) => {
  if (!isArray(template?.attributes)) {
    return false;
  }

  const esimLabel = findAttributeLabelByName(
    template,
    ESIM_SIGNUP_PRIMARY_NAME
  );
  const simCardLabel = findAttributeLabelByName(
    template,
    SIM_CARDS_PRIMARY_NAME
  );

  const hasEsimField = !isUndefined(esimLabel);
  const hasSimCardField = !isUndefined(simCardLabel);

  if (!hasEsimField && !hasSimCardField) {
    return false;
  }

  if (hasEsimField && hasSimCardField) {
    return (
      values?.[esimLabel] !== true && isStringEmpty(values?.[simCardLabel])
    );
  }

  if (hasEsimField) {
    return values?.[esimLabel] !== true;
  }

  return isStringEmpty(values?.[simCardLabel]);
};

const findAttributeLabelByName = (template, attributeName) => {
  const attribute = template?.attributes?.find(
    el => el?.name === attributeName
  );
  return attribute?.label;
};
